<template>
    <v-dialog-old ref="dialog" id="feedbackRequestDialog">
        <ValidationObserver ref="feedbackRequestForm">
            <fieldset>
                <legend>Запрос отзыва</legend>

                <label>Имя</label>
                <vee-input rules="required" v-model="request.name"/>

                <label>Телефон</label>
                <ValidationProvider v-slot="{ errors }" rules="required|phone">
                    <input v-mask="'+7 (###) ###-##-##'"
                           v-model="request.phone"
                           :class="{'hasError' : errors[0]}"
                           v-tooltip="{content: errors[0], template: $errTemplate}">
                </ValidationProvider>

                <label>Дата визита</label>
                <table>
                    <tr>
                        <td width="58%" style="padding-right: 10px;">
                            <date-piker v-model="request.visit_date"
                                        rules="required"
                                        :default-value="today"
                                        :clearable="false"
                                        :disable-highlighting="true"
                                        style="height: 24px"/>
                        </td>
                        <td width="21%">
                            <input type="radio" v-model="selectedDay" value="TODAY"> Сегодня
                        </td>
                        <td width="21%">
                            <input type="radio" v-model="selectedDay" value="YESTERDAY"> Вчера
                        </td>
                    </tr>
                </table>
            </fieldset>
        </ValidationObserver>

        <footer>
            <v-loading-component @click="submit">
                <template slot-scope="{ loadingClass }">
                    <button :class="['green', loadingClass]">
                        Добавить
                    </button>
                </template>
            </v-loading-component>
        </footer>
    </v-dialog-old>
</template>

<script>
export default {
    data: function () {
        return {
            request: {
                name: '',
                phone: '',
                visit_date: '',
            },
            selectedDay: 'TODAY',
        };
    },
    methods: {
        show () {
            this.request = {
                name: '',
                phone: '',
                visit_date: this.today,
            };
            this.selectedDay = 'TODAY';

            this.$refs.dialog.show();
        },
        submit(btn) {
            btn.startLoadingAnimation();

            this.$refs.feedbackRequestForm.validate().then(success => {
                if (!success) {
                    btn.stopLoadingAnimation()
                    return;
                }

                this.axios.post('requests/create', this.request).then(() => {
                    this.$emit('updated');
                    this.$refs.dialog.hide();
                });
            });
        },
    },
    computed: {
        today() {
            return this.$moment().format('DD.MM.YYYY');
        },
        yesterday() {
            return this.$moment().subtract(1, 'days').format('DD.MM.YYYY');
        },
    },
    watch: {
        selectedDay(val) {
            if (val === 'TODAY') {
                this.request.visit_date = this.today;
            } else if (val === 'YESTERDAY') {
                this.request.visit_date = this.yesterday;
            }
        },
        'request.visit_date'(val) {
            if (val !== this.today && val !== this.yesterday) {
                this.selectedDay = '';
            }
        },
    },
}
</script>

<style lang="scss">
#feedbackRequestDialog {
    width: 516px;

    td {
        text-align: end;

        input[type=radio] {
            margin-right: 0;
        }

        .mx-input {
            padding-bottom: 2px;
            margin-bottom: 0;
        }
    }
}
</style>
